// extracted by mini-css-extract-plugin
export default {"inputDiv":"Input__inputDiv","inputInfoText":"Input__inputInfoText","inputField":"Input__inputField","inputHeading":"Input__inputHeading"};